const styles = {
    avatar: {
        height: '40px',
        width: '40px',
    },
    warningMessage: {
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "18px",
        lineHeight: "20px",
        letterSpacing: "0.1px",
        color: "#424F49",
        width: "296px",
        marginTop: "48px",
        textAlign: "center",
        display:"block",
        marginLeft: "auto",
        marginRight: "auto"
    },
    inputLabel: {
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "18px",
        letterSpacing: "0.2px",
        color: "#424F49",
        padding: "0",
        margin: "0",
        marginLeft: "23px",
        marginTop: "62px",
    },
    inputWrapper: {
        margin: "0",
        padding: "0",
        marginTop: "8px",
        marginLeft: "23px",
        width: "328px",
        zIndex: 100,
    },
    infoMessage: {
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize:"13px",
        ineHeight: "16px",
        letterSpacing: "0.2px",
        color: "#6D7885",
        marginLeft: "28px",
        width: "304px",
        marginTop: "5px"
    },
    saveButton : {
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "15px",
        lineHeight: "20px",
        letterSpacing: "0.2px",
        width: "109px",
        borderRadius: "8px",
        backgroundColor: "#06844D",
        height: "36px",
        marginTop: "34px",
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto'
    }
}

export default styles;
